export default function AchorIcon(props: any) {
    return (
        <svg width="1em" height="1em" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_1329_9799)">
                <rect width="28" height="28" rx="14" fill="white" fillOpacity="0.2" />
                <path d="M21 11.6667L14 18.6667L7 11.6667" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            </g>
            <defs>
                <clipPath id="clip0_1329_9799">
                    <rect width="28" height="28" rx="14" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}
